// import "./App.css";
import { useEffect, useState, useRef } from "react";
import Simulator from "./opencv/Simulator";
import * as fr from "./translations/fr.json";
import * as de from "./translations/de.json";
import * as it from "./translations/it.json";
import * as es from "./translations/es.json";

function App() {
  const [language, setLanguage] = useState("en");
  const [showSimulator, setShowSimulator] = useState(localStorage.getItem("simulator-form-submitted") == "1");
  const hubspotFormRef = useRef(null);
  const hubspotScriptLoaded = useRef(false);

  const t = (str) => {
    switch (language) {
      case "fr":
        return fr[str];
      case "de":
        return de[str];
      case "it":
        return it[str];
      case "es":
        return es[str];
      default:
        return str;
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const queryParamLanguage = queryParams.get("language");
    setLanguage(queryParamLanguage || "en");
  }, []);

  // Load HubSpot script and initialize form
  useEffect(() => {
    if (showSimulator || hubspotScriptLoaded.current) return;

    let formSubmitted = false;

    const handleFormSubmission = () => {
      // Set cookie/localStorage when form is submitted
      localStorage.setItem("simulator-form-submitted", "1");
      // Show simulator after a short delay
      setTimeout(() => {
        setShowSimulator(true);
      }, 1200);
    };

    const initializeHubSpotForm = () => {
      if (window.hbspt && hubspotFormRef.current) {
        window.hbspt.forms.create({
          portalId: "47009436",
          formId: "257b8adb-1bef-4ce6-a70a-14ff9f441b41",
          region: "na2",
          target: '#hubspot-form-container',
          onFormSubmit: ($form, data) => {
            console.log('HubSpot form submitted successfully', data);
            if (!formSubmitted) {
              formSubmitted = true;
              handleFormSubmission();
            }
          }
        });
        hubspotScriptLoaded.current = true;
      }
    };

    let script = null;

    // Check if HubSpot script is already loaded
    if (window.hbspt) {
      initializeHubSpotForm();
    } else {
      // Load HubSpot script
      script = document.createElement('script');
      script.src = '//js-na2.hsforms.net/forms/embed/v2.js';
      script.charset = 'utf-8';
      script.type = 'text/javascript';
      script.async = true;
      
      script.onload = () => {
        initializeHubSpotForm();
      };

      document.body.appendChild(script);
    }

    // Cleanup function
    return () => {
      if (script && document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, [showSimulator]);

  return (
    <>
      {showSimulator && <Simulator isBlurred={!showSimulator} />}

      {!showSimulator && <>
        <div
          className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none py-4"
          style={{ zIndex: 1200 }}
        >
          <div className="relative w-auto mx-4 my-auto" style={{ width: '95%', maxWidth: '900px' }}>
            {/*content*/}
            <div className="border-0 shadow-lg relative flex flex-col w-full bg-white rounded-md outline-none focus:outline-none" style={{ maxHeight: '85vh' }}>
              {/*header*/}
              <div className="flex items-start justify-between py-4 px-6 sticky top-0 bg-white z-10 border-b flex-shrink-0">
                <div className="text-center w-full">
                  <h3 className="text-xl font-semibold">
                    {t("Discover your new face")}
                  </h3>
                  <h5 className="text-sm font-light">
                    {t("Fill out the form below to access Dr. Brian Boxer Wachler's simulator and try our colors for free.")}
                  </h5>
                </div>
              </div>

              {/*body*/}
              <div className="relative px-6 py-4 overflow-y-auto flex-1" style={{ minHeight: 0 }}>
                <p className="my-4 text-blueGray-500 text-sm leading-relaxed">
                  {t("By submitting your information, you agree to have the Boxer Wachler Vision Institute contact you about the procedure.")}
                  <br />
                  <strong>To use the ColorEyes&trade; simulator, allow boxerwachler.com to use your camera.</strong>
                </p>
                {/* HubSpot form container */}
                <div 
                  id="hubspot-form-container"
                  ref={hubspotFormRef}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black" />
      </>}
    </>
  );
}

export default App;
